<template>
  <div class="search-lib-page full-parent" :class="isClient ? '' : 'search-brower'">

    <div class="comp-search" v-if="$route.query.compId">
      <i class="el-icon-search"></i>
      <span>搜索“{{$route.query.compName}}”的零部件</span>
    </div>

    <div class="scroll-content">
      <!-- 输入搜索区域 -->
      <search-input @fresh-search="freshSearch" ref="SearchInput" />
      <!-- 快捷筛选项 -->
      <div class="search-filter">
        <search-filter
          title="场景"
          :screen-width="screenWidth"
          :dataSource="filterDataSource['scenes']"
          @search="prodSearch"
          ref="scenes"
          v-show="filterDataSource['scenes'].length > 0"
        />
        <search-filter
          title="细分"
          :screen-width="screenWidth"
          :dataSource="filterDataSource['subdivision']"
          v-show="filterDataSource['subdivision'].length > 0"
          @search="prodSearch"
          ref="subdivision"
        />
        <search-filter
          title="特征"
          :screen-width="screenWidth"
          :dataSource="filterDataSource['feature']"
          v-show="filterDataSource['feature'].length > 0"
          @search="prodSearch"
          ref="feature"
        />
      </div>
      <!-- 排序方式 -->
      <other-filter :count="total" @search="prodSearch" @getAdvert="_queryAdverts" ref="OtherFilter" />
      <!-- 产品列表 -->
      <div v-loading="loading" style="padding: 4px 16px 0 16px">

        <div class="prod-list-area">
          <div class="prod-list-content">

            <ad-advert :comp="comp" v-for="comp in adverts" :key="comp.AdvID"></ad-advert>
            
            <div class="prod-list-block" v-for="(item, index) of advPos" :key="`adv_pos_${index}`">
               <list-card :data="item" class="tuiguang">
              <template #footer>
                <div class="badge-m">推广</div>
              </template>
            </list-card>
            </div>
            <!-- <list-card :data="item" v-for="(item, index) of advPos" :key="`adv_pos_${index}`" class="tuiguang">
              <template #footer>
                <div class="badge-m">推广</div>
              </template>
            </list-card> -->
            <div class="prod-list-block" v-for="(item, index) of equalityData" :key="`equality_${index}`">
              <list-card :data="item"></list-card>
              </div>
            <div
              class="prod-list-block"
              v-for="(item, index) of dataSource"
              :key="index"
              @mouseenter="_cardMouseenter(index, 1000)"
              @mouseleave="_cardMouseleave(index)"
            >
              <list-card :data="item"></list-card>
              <conceal-product :data="item" ref="conceal_product" v-if="!$route.query.compId"></conceal-product>
              <div class="conceal_btn" @click.stop="_cardMouseenter(index)" v-if="!$route.query.compId">正在展开搜索</div>
            </div>

            <div class="list-card-empty" v-for="item of 20" :key="`key_${item}`"></div>
          </div>
        </div>

        <el-empty description="搜索不到呀~" v-if="adverts.length <= 0 && advPos.length <= 0 && dataSource.length <= 0"></el-empty>

      </div>
    </div>
    <div class="list-pagination">
      <md-page :page="page" :total="count" :pageSize="pageSize" @pagecallback="handleCurrentChange"></md-page>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import {AdvertsType, AdvertsService, UtilLibs, CheckLibs} from '@digital-supply-chain/module'

import SearchInput from "../components/search-input.vue";
import SearchFilter from "./components/search-filter.vue";
import OtherFilter from "./components/other-filter.vue";
import ConcealProduct from "./components/concealProduct.vue";
import AdAdvert from "./components/ad-advert.vue";

import ListCard from "@/components/card-list.vue";
import {includesCheck} from '@/utils/utils';
import { TodaySearchService, AdService, ProductService, AuthService } from "@/service";

export default {
  components: {
    SearchInput,
    SearchFilter,
    OtherFilter,
    ListCard,
    ConcealProduct,
    AdAdvert,
  },
  data() {
    return {
      screenWidth: 0, // 屏幕内容宽度
      filterDataSource: {
        feature: [],
        scenes: [],
        subdivision: [],
      }, // 筛选词

      page: 1,
      pageSize: 100,
      count: 0,
      total: 0,
      dataSource: [], // 产品列表
      equalityData: [], // 企业名称全匹配的产品数据

      adverts: [],
      advPos: [],

      defaultKeyWord: "",
      loading: false,

      isClient: CheckLibs.isClient(),
    };
  },
  computed: {
    ...mapGetters({
      historys:'search/historys',
    }),
  },
  methods: {
    ...mapMutations({
      setSearchHistory: 'search/setSearchHistory'
    }),

    getParams() {
      let keyword =
        this.$refs.SearchInput.keyword || this.$route.params.keyword; // 避免用户将搜索框删除后进行操作
      let { sort, hasModel, standard, showAdv } = this.$refs.OtherFilter;
      let scenes = this.$refs.scenes.selectArray;
      let subdivision = this.$refs.subdivision.selectArray;
      let feature = this.$refs.feature.selectArray;
      let data = {
        keyword, // 关键词
        page: this.page, // 页码
        pageSize: this.pageSize, // 页数
        sort, // 排序方式
        cId: '', // cId
        scenes, // 场景
        subdivision, // 细节
        feature, // 特征
        hasStandardParts: standard ? '1' : '',
        showAdv,
      };
      hasModel && (data.hasModel = '1'); // 是否有模型
      return data;
    },

    // 获取产品列表
    async prodSearch(page = 1) {
      this.loading = true;
      if (page === 1) {
        this.page = 1;
      } else {
        this.dataSource = [];
      }
      this.equalityData = [];
      let data = this.getParams();
      data.keyword && (this.setSearchHistory(data.keyword));
      this.$route.query.compId && (data.compId = this.$route.query.compId)
      // console.log(data);
      const res = await TodaySearchService.prodSearch(data);
      if (res.code === 0) {
        this.dataSource = res.data.list.map(item => {
          let newItem = {};
          Object.keys(item).forEach(v => {
            newItem[v.slice(0, 1).toUpperCase() + v.slice(1)] = item[v];
          })
          return newItem;
        });
        this.count = res.data.count || 0;
        this.total = res.data.total || 0;
        this.filterDataSource = res.data.condition;
        this.$nextTick(() => {
          this.getOneCompanySearch();
        })
      }
      this.loading = false;
    },

    async getOneCompanySearch() {
      const dataArr = this.dataSource;
      const prodIds = this.dataSource.map(item => item.ProdId);
      const keyword = this.$refs.SearchInput.keyword || this.$route.params.keyword; // 避免用户将搜索框删除后进行操作
      const findOneName = dataArr.find(item => (item.CompName||'').replace(/<em>/g,'').replace(/<\/em>/g,'') === keyword);
      if (!findOneName || this.$route.query.compId) {
        return false;
      }
      const viewWidth = document.querySelector('.prod-list-content').clientWidth;
      const listWidth = document.querySelector('.prod-list-block').clientWidth;
      const pageSize = parseInt(viewWidth / listWidth, 10);
      const res = await TodaySearchService.prodSearch({
        keyword,
        compId: findOneName.CompId,
        page:1,
        pageSize,
        sort: this.$refs.OtherFilter.sort, // 排序方式
      });
      if(res.code === 0) {
        this.equalityData = res.data.list.filter(item => !prodIds.includes(item.prodId)).map(item => {
          let newItem = {};
          Object.keys(item).forEach(v => {
            newItem[v.slice(0, 1).toUpperCase() + v.slice(1)] = item[v];
          })
          newItem.CompName = `<em>${newItem.CompName}</em>`;
          return newItem;
        });
      }
    },

    // 重置地址，以实现关键词的变更，其他筛选项的状态重置
    freshSearch(keyword) {
      this.$router.replace(`/search/lib/${keyword}`);
    },
    async pageStart(keyword) {
      this.$refs.SearchInput.keyword = keyword; // 修改搜索输入框中的文字
      await this.prodSearch(); // 获取产品列表
      this.$refs.SearchInput.getSearchKeyword(); // 获取关联词
      await this._queryAdverts()
    },
    // 分页搜素
    handleCurrentChange(_page) {
      this.page = _page.page;
      this.prodSearch(_page.page);
    },

    // 鼠标划上
    _cardMouseenter(index, time = 0) {
      if (this.$route.query.compId) return;
      this.listOtherTimeOut && clearTimeout(this.listOtherTimeOut);
      const indexOffset = this.equalityData.length + this.adverts.length + this.advPos.length;
      this.listOtherTimeOut = setTimeout(() => {
        this.$refs.conceal_product[index].show(index, this.getParams(), time === 0 ? 'click' : 'hover', indexOffset);
      }, time)
    },
    // 鼠标移出
    _cardMouseleave(index) {
      if (this.$route.query.compId) return;
      this.listOtherTimeOut && clearTimeout(this.listOtherTimeOut);
      this.$refs.conceal_product[index].hide();
    },

    /**一行显示的数量 */
    _getRowCount() {
      const viewWidth = document.querySelector('.prod-list-content').clientWidth;
      const listWidth = document.querySelector('.list-card-empty').clientWidth;
      return parseInt(viewWidth / listWidth, 10);
    },


    // ====================================
    // ============ 新的广告 START =========
    // ====================================
    async _queryAdverts(type = AdvertsType.SearchComp) {
      if (this.$route.query.compId) {
        return false;
      }
      let data = this.getParams();
      if (!data.showAdv) {
        this.adverts = [];
        this.advPos = [];
        return false;
      }
      const levelName = {
        '金牌': 32,
        '银牌': 4,
        '铜牌': 2,
        '仅认证': 0,
      };
      const option = {
        type,
        limit: this._getRowCount(),
        random: true,
        match: true,
        keyword: data.keyword
      }
      if (type == AdvertsType.SearchProduct) {
        const limitOffset = this._getRowCount() - this.adverts.length;
        option.limit = this._getRowCount() * 2 + limitOffset;
      }
      let res = await AdvertsService.queryAdverts(option);
      if (!res) {
        return false;
      }
      if (type === AdvertsType.SearchComp) {
        this.adverts = res;
        this._queryAdverts(AdvertsType.SearchProduct);
      } else {
        res = res.map(item => {
          const data = {};
          Object.keys(item).forEach(v => {
            data[UtilLibs.titleCase(v)] = item[v];
          })
          data.VipLevel = levelName[item.level]
          return data;
        })
        this.advPos = res;
      }
    },
    // ====================================
    // ============ 新的广告 END ===========
    // ====================================


    // ====================================
    // ============ 老的广告部分 ===========
    // ====================================
    // 广告部分
    async _getAdvert() {
      if (this.$route.query.compId) {
        return false;
      }
      let data = this.getParams();
      if (!data.showAdv) {
        this.adverts = [];
        this.advPos = [];
        return false;
      }
      const res = await AdService.getAdvert(data.keyword, 1, 2);
      if (res) {
        this.adverts = res.concat(AdService.getSpecialAds({ q: data.keyword }));
      }
      this._getProductAdvert();
    },
    // 获取推广企业
    async _getProductAdvert() {
      if (this.advPos.length > 0) {
        return false;
      }
      const viewWidth = document.querySelector('.prod-list-content').clientWidth;
      const listWidth = document.querySelector('.list-card-empty').clientWidth;
      const rowCount = parseInt(viewWidth / listWidth, 10);
      let data = this.getParams();
      const res = await ProductService.prodGetSlist({
        sort: 0,
        q: data.keyword,
        adv_pos: 1,
        limit: 2,
        pageSize: rowCount * 2 - this.adverts.length,
      });
      let fixedProduct = [];
      let fixedProductId = [];
      if (AuthService.user().CompID == 0 && includesCheck(data.keyword, ['减速机','升降机','行星'])) {
        fixedProduct = [
          {"Score":3.3720968,"ProdID":181030000063,"ProdName":"KS187轴输入螺旋锥齿轮<font color='red'><b>减速机</b></font>","PromoteName":"","ProdLogo":"prod/logo/181030000063/1086651","HasModel":1,"ViewNums":12,"DownNums":3,"SaleNums":0,"MaxPrice":0,"MinPrice":0,"CompID":33476,"CompMdt":"80044044","CompName":"上海兆迈传动机械有限公司","CompLogo":"images/2020/04/complogo_33476","CompVipLevel":33,"AdvertPosition":0},
          {"Score":3.3720968,"ProdID":200415000196,"ProdName":"NMRV025蜗轮蜗杆<font color='red'><b>减速机</b></font>","PromoteName":null,"ProdLogo":"prod/logo/200415000196/1203534","HasModel":1,"ViewNums":38,"DownNums":12,"SaleNums":0,"MaxPrice":0,"MinPrice":0,"CompID":45945,"CompMdt":"80057690","CompName":"诺求（上海）智能科技有限公司","CompLogo":"images/2020/12/complogo_45945","CompVipLevel":33,"AdvertPosition":0}
        ];
        fixedProductId = [181030000063, 200415000196];
      }
      if (res) {
        const listData = res.List.filter(item => (!fixedProductId.includes(item.ProdID))).slice(0, rowCount * 2 - this.adverts.length);
        this.advPos = fixedProduct.concat(listData);
      }
    }
    // ====================================
    // ============ 老的广告部分 ===========
    // ====================================

  },
  mounted() {
    let { keyword } = this.$route.params;

    document.title = `搜索：${keyword}`;

    this.pageStart(keyword);

    // this._queryAdverts();
    // this._getAdvert();

    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  beforeRouteUpdate(to, from) {
    if (to.fullPath !== from.fullPath) {
      this.pageStart(to.params.keyword);
    }
  },
};
</script>

<style lang="less">
.search-lib-page {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding: 16px 0;
  overflow-x: hidden;
  &.search-brower{
    padding-top: 52px;
  }
  p {
    margin: 0;
  }
  .badge-m{
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 12px;
    color: #ffffff;
    width: 32px;
    height: 16px;
    text-align: center;
    background: rgba(51, 51, 51, 0.6);
    line-height: 15px;
  }
}

.equality-list-content{
  display: flex;
  flex-wrap: wrap;
  height: 241px;
  margin-bottom: 10px;
}

.search-filter{
  margin-top: 16px;
}

.scroll-content {
  flex: 1;
}

.prod-list-area {
  width: 100%;
}

.prod-list-content{
  display: flex;
  flex-wrap: wrap;
}
.prod-list-block {
  min-width: 150px;
  max-width: 180px;
  margin: 0 5px 10px 5px;
  flex: 1;
  border: 1px solid #d6d6d6;
  position: relative;
  &>.list-card{
    margin: 0;
    position: initial;
    height: 100%;
    border: 0 none;
    min-width: 100%;
  }
}

.list-pagination {
  position: sticky;
  left: 0;
  bottom: 0;
}
.comp-search{
  display: flex;
  align-items: center;
  color: @text-color-call-out;
  font-size: 13px;
  padding-left: 21px;
  span{
    margin-left: 4px;
  }
}

.conceal_btn{
  position: absolute;
  right: 0;
  top: 150px;
  visibility: hidden;
  opacity: 0;
  font-size: 14px;
  transition: top .3s ease,opacity .1s ease .1s;
  width: 95px;
  background: rgba(0,0,0,.7);
  line-height: 25px;
  color: #ffffff;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
}
.prod-list-block:hover{
  .conceal_btn{
    top: 125px;
    opacity: 1;
    visibility: visible;
  }
}
</style>